/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import RichLabel from 'loracoms/RichLabel';
import ShowIf from 'loracoms/ShowIf';
import CSSModules from 'react-css-modules';
import styles from './styles/main.scss';


const propTypes = {
  options: React.PropTypes.array.isRequired,
  onChange: React.PropTypes.func.isRequired,
};

class RingSwitcher extends React.Component {
  constructor(props) {
    super(props);
    let active = 0;
    props.options.forEach((opt, idx) => {
      if (opt.active) {
        active = idx;
      }
    });
    this.state = {
      active,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { options, onChange } = this.props;
    let { active } = this.state;
    active = (active + 1) % options.length;
    onChange(options[active].value);
    this.setState({
      active,
    });
  }

  render() {
    const { options } = this.props;
    const { active } = this.state;
    const opts = options.map((opt, idx) => (
      <ShowIf if={idx === active} key={idx}>
        <a onClick={this.handleClick}>
          <RichLabel content={opt.label} />
        </a>
      </ShowIf>
    ));
    return (
      <div styleName="ring-switcher"> {opts} </div>
    );
  }
}

RingSwitcher.propTypes = propTypes;

export default CSSModules(RingSwitcher, styles, { allowMultiple: true });




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/LRAPView/coms/RingSwitcher/index.jsx